exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".advert-content[data-v-79ce0c6e]{min-width:960px;padding-top:80px;text-align:center}.advert-item[data-v-79ce0c6e]{display:inline-block;width:300px;height:300px;line-height:300px;color:#fff;font-size:24px;text-align:center;background-color:#999;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-79ce0c6e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/advert/advertType.vue
// module id = 585
// module chunks = 0